export default __webpack_public_path__ + "static/media/Z_wdt_c_cap_1.698a26b2.mp3";